import { render, staticRenderFns } from "./TextAndImageRight.vue?vue&type=template&id=60badced&"
import script from "./TextAndImageRight.vue?vue&type=script&lang=js&"
export * from "./TextAndImageRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports